export const enData = `
  <div class="paragraph">
    <div class="title">TERMS AND CONDITIONS</div>
    <div class="text-box">
      <div class="text">
        <br><br>
        This Trade-In Service ("Service") is provided by Danghuan Europe S.L., a company
        incorporated under Spanish law and registered at Madrid, Spain, 28045, VAT ID:
        B19961911 (hereinafter "Danghuan"), with email: legal@danghuan.eu. The OPPO
        entities, Reflection Investment B.V. for Spain and France and Unumplus Limited for the
        United Kingdom (collectively referred to as "OPPO"), promote the availability of this
        Trade-In Service on their respective official websites. However, OPPO does not operate,
        manage, or process any part of the trade-in program.
        <br><br>
        This document governs the terms and conditions under which consumers residing in the
        European Union may participate in the official trade-in program for designated
        smartphone purchases. The program is operated in full compliance with European Union
        law, particularly Directive 2011/83/EU on consumer rights and Regulation (EU) 2016/679
        (GDPR) on data protection.
        <br><br>
        For consumers residing in the United Kingdom, the Trade-In Program is governed in
        accordance with applicable UK law, including the Consumer Rights Act 2015 and the UK
        General Data Protection Regulation (UK GDPR), which incorporates and adapts the
        principles of Regulation (EU) 2016/679 as retained in UK law under the Data Protection
        Act 2018.
        <br><br>
        ARTICLE 1 – TERRITORIAL SCOPE AND PRODUCTS
        <br><br>
        1.1. The trade-in Service is available to individuals aged 18 or older who legally reside
        in any member state of the European Union or in the United Kingdom.
        <br><br>
        1.2. Customers must act in a personal (non-professional) capacity and qualify as
        “consumers” under Directive 2011/83/EU (for EU residents) or under the Consumer
        Rights Act 2015 (for UK residents).
        <br><br>
        1.3. One used device may be traded in per qualifying transaction.
        <br><br>
        1.4. The trade-in Service is exclusively available to customers who purchase eligible
        OPPO products (“Product”) through the official OPPO online stores in France, Spain, or
        the UK during the applicable campaign period. Only designated OPPO models are
        eligible.
        <br><br>
        1.5. The traded-in device must be listed among the eligible models published on the
        official website and must meet the functionality and ownership criteria detailed in Article
        5.
        <br><br>
        1.6. The customer may deliver only one (1) Used Device for each Product purchased.
        <br><br>
        ARTICLE 2 – CONTRACTUAL CONDITIONS
        <br><br>
        2.1. The trade-in Service operates independently from the purchase of any Product and
        does not constitute a bundled or joint offer with any device manufacturer, distributor, or
        retailer.
        <br><br>
        2.2. All operational responsibilities for the Service, including customer communication,
        device logistics, valuation, payments, and personal data processing, are solely borne by
        Danghuan Europe S.L.
        <br><br>
        2.3. Nothing in these Terms and Conditions shall limit or prejudice the statutory rights
        granted to consumers under applicable laws, including but not limited to Directive
        2011/83/EU and the UK Consumer Rights Act 2015.
        <br><br>
        2.4. Danghuan reserves the right to reject any trade-in request in cases of suspected
        fraud, abuse, or violation of the Service Terms, including but not limited to submissions
        made by third parties on behalf of another user.
        <br><br>
        ARTICLE 3 – SERVICE PARTICIPATION PROCESS
        <br><br>
        3.1. Customers may enroll in the trade-in Service during the checkout process on the
        designated OPPO online store.
        <br><br>
        3.2. To proceed, customers must complete a self-assessment questionnaire and submit
        the required device information, including but not limited to the IMEI, model, and
        condition.
        <br><br>
        • Please ensure that the model of your old device is selected correctly. If any changes
        are needed, please contact us as soon as possible at oppo@danghuan.eu so we
        can update the device information accordingly.
        <br><br>
        3.3. Customers must provide accurate and valid bank account details for payment
        purposes at the time of registration:
        <br><br>
        • For EU/EEA residents: a SEPA-compliant IBAN issued by a financial institution
        located within the SEPA zone.
        <br><br>
        • For UK residents: a GBP-denominated bank account held in their name, including
        Sort Code and Account Number, for payment via Faster Payments or BACS.
        <br><br>
        3.4. Customers will receive a trade-in instruction email within 24 hours after the new
        device is marked as delivered in the logistics system.
        <br><br>
        3.5. Customers must upload all required documentation (e.g., the signed integrity
        declaration) and ship the used device within 10 calendar days from the delivery date of
        the new device. Valid tracking must confirm shipment initiation within this period.
        <br><br>
        3.6. Failure to complete the above steps within the defined timeframe will result in
        automatic cancellation of the trade-in request.
        <br><br>
        3.7. Incomplete, inconsistent, or inaccurate submissions, such as a mismatched IMEI or
        missing documentation, may result in rejection of the trade-in without further
        compensation.
        <br><br>
        3.8. The used device must be securely packaged in accordance with the shipping
        instructions provided. Shipping is prepaid by Danghuan. In case of non-delivery or
        damage during transit, the customer must contact oppo@danghuan.eu within 15
        calendar days from the last tracking update. Danghuan will then provide access to the
        official UPS claims channel and assist the customer in filing the claim.
        <br><br>
        Please note that logistics claims must be submitted within 60 days from the label creation
        date. Any approved compensation will be transferred directly to the IBAN account
        provided by the customer. Danghuan assumes no liability for reimbursement in such
        cases.
        <br><br>
        3.9. Devices returned without the required integrity declaration or signed sales
        confirmation will not be processed. The customer will be notified via email and may
        request the device to be returned within 10 calendar days of receiving the notification.
        Return shipping costs will apply as per Article 6.3. If no request is received within this
        period, Danghuan reserves the right to responsibly recycle or dispose of the device
        without further obligation or liability.
        <br><br>
        3.10. Eligible products for trade-in include smartphones, smartwatches, wireless
        earphones, and tablets, as listed and accepted on the official OPPO website at the time
        of participation.
        <br><br>
        ARTICLE 4 – DEVICE ACCEPTANCE CONDITIONS
        <br><br>
        4.1. Only devices listed on the eligible model list published on OPPO website (including
        smartphones, smartwatches, wireless earphones, and tablets, etc.) are accepted under
        the Trade-In Program.
        <br><br>
        4.2. All devices must meet the grading and cosmetic standards defined by Danghuan.
        Devices will be categorized into Grade A, B, or C based on certified inspection tools and
        physical condition, as detailed in Article 6.
        <br><br>
        4.3. Devices must meet the following minimum functionality and condition criteria:
        <br><br>
        – Smartphones and Tablets: Must power on, have a functional touchscreen and battery,
        show no major physical damage (e.g., cracked screen, corrosion), and be fully reset to
        factory settings with all security locks (e.g., PIN, Apple iCloud, Google FRP, Samsung,
        Xiaomi) disabled.
        <br><br>
        – Smartwatches: Must power on, be free from active account locks (e.g., iCloud, Google,
        Samsung), and function correctly with no severe physical damage.
        <br><br>
        – Wireless Earphones: Must include both earpieces and the charging case, be capable
        of charging and pairing, and not show signs of water damage or deep structural cracks.
        <br><br>
        4.4. All devices must be the sole property of the customer and not be under lease, finance
        agreement, or subject to any third-party ownership. Devices reported as lost, stolen,
        counterfeit, or tampered (e.g., with altered serial number or IMEI) will be rejected without
        compensation.
        <br><br>
        4.5. Devices failing to meet minimum eligibility may be returned if requested by the
        customer within 7 days of notification. Notification will be sent by email. Otherwise, they
        may be responsibly recycled.
        <br><br>
        If the customer requests the return of such ineligible device, the return process and
        shipping costs will follow the same conditions as described in Article 6.3.
        <br><br>
        ARTICLE 5 – LOGISTICS TIMELINE AND OBLIGATIONS
        <br><br>
        5.1. Customers must ship their used device within 10 natural days of receiving the new
        OPPO device.
        <br><br>
        5.2. Reminder emails will be issued by Danghuan on Day 3 (D+3), Day 6 (D+6), and Day
        9 (D+9) post-delivery.
        <br><br>
        5.3. All devices must be shipped using the prepaid shipping label provided by Danghuan
        Europe S.L.
        <br><br>
        5.4. If the shipping label is not scanned by the logistics provider by Day 15 (D+14), the
        trade-in will be automatically cancelled.
        <br><br>
        5.5. Devices must be packaged securely to prevent damage in transit; Danghuan
        provides packaging instructions but not physical materials.
        <br><br>
        5.6. Devices received with mismatched IMEI or different conditions than reported may
        result in adjusted valuation or cancellation.
        <br><br>
        ARTICLE 6 – INSPECTION, QUOTATION, ACCEPTANCE
        <br><br>
        6.1. Devices are inspected within 3 business days of receipt at the designated
        warehouse. The inspection process includes both functional diagnostics using certified
        tools and a visual assessment to determine cosmetic condition (Grade A, B, or C).
        <br><br>
        6.2. If the condition or specifications of the device differ from the customer’s original
        submission, Danghuan Europe S.L. will send a revised quote via email, specifying the
        adjusted grade and rationale.
        <br><br>
        6.3. Customers have 7 calendar days from the date of notification to accept or reject the
        revised trade-in quotation. During this period, they may request the return of their device.
        <br><br>
        • For customers residing in Spain, Danghuan Europe S.L. will cover the return
        shipping cost.
        <br><br>
        • For customers in other countries, the customer is responsible for paying the
        return shipping cost, up to a maximum of EUR €22 (GBP £19), VAT included,
        using the official prepaid return label provided by Danghuan. Payment details will
        be provided by Danghuan upon request or included in the payment link email.
        <br><br>
        Customers may pay the return shipping cost via one of the following methods:
        <br><br>
        • For EU/EEA customers: SEPA bank transfer to Danghuan’s IBAN.
        <br><br>
        • For UK customers: GBP bank transfer to Danghuan’s UK bank account, using
        Sort Code and Account Number, via Faster Payments or BACS.
        <br><br>
        If payment is not received within 10 calendar days from the date the payment request
        is sent, Danghuan reserves the right to treat the revised quote as accepted and
        process the device accordingly.
        <br><br>
        Refunds for any return shipping cost paid by the customer shall be issued via bank
        transfer within 5 business days after the payment has been verified by Danghuan. The
        refund will be made to the same bank account originally provided by the customer
        during trade-in registration.
        <br><br>
        6.4. If the customer does not respond to the revised quotation within 7 calendar days,
        Danghuan customer service will attempt to contact the customer directly to confirm
        acceptance or rejection. If no response is received within 30 calendar days from the
        notification date, the revised quotation will be deemed rejected, In addition, for
        customers residing outside Spain, a return shipping fee applies. The customer must
        pay the applicable fee for their country within 5 calendar days after receiving the
        payment request. Once payment is confirmed, Danghuan will verify the transaction
        within 5 business days and arrange the return shipment to the customer’s original
        address provided during the trade-in registration of Danghuan, The customer will be
        notified by email once the shipment has been dispatched, including the corresponding
        tracking information. The customer is responsible for actively monitoring the status 
        of the return shipment and for arranging timely collection or receipt of the parcel 
        where required. Danghuan Europe S.L. will notify the customer in advance by email of 
        the return shipment tracking number and relevant logistics information. If the customer 
        fails to collect or receive the parcel within the timeframe specified by the logistics provider, 
        resulting in the parcel being returned or requiring re-dispatch, any additional shipping or 
        handling costs incurred shall be borne solely by the customer. Danghuan Europe S.L. 
        shall not be held liable for any such costs or consequences.
        <br><br>
        6.5. Devices deemed non-eligible due to irreparable damage, tampering, or ineligibility
        (e.g., iCloud locked, stolen, or with mismatched IMEI) will receive no valuation.
        Customers will have 7 calendar days from notification to request a return; otherwise, the
        device may be responsibly recycled.
        <br><br>
        6.6. Payment for accepted devices will be issued within 3 business days from the date
        of acceptance, via SEPA bank transfer.
        <br><br>
        6.7. Device Grading Criteria:
        Devices are evaluated and classified as follows. Each product category (smartphone,
        tablet, smartwatch, earphones) is subject to category-specific requirements:
        <br><br>
        I. Smartphones and Tablets
        <br><br>
        Grade A – Excellent Condition
        <br><br>
        • Device shows normal signs of use but remains in good condition.
        <br><br>
        • No cracks, dents, or paint loss.
        <br><br>
        • All functions (screen, touch, camera, buttons, speaker, battery, connectivity, etc.)
        operate normally.
        <br><br>
        • For Apple devices, battery health ≥ 90%.
        <br><br>
        Grade B – Light Signs of Use
        <br><br>
        • Device shows normal signs of use but remains in good condition.
        <br><br>
        • May have 2–3 minor scratches or small scuffs; no major damage.
        <br><br>
        • All key functions (display, touch, sensors, Bluetooth) operate normally.
        <br><br>
        • For Apple devices, battery health ≥ 80%
        <br><br>
        Grade C – Visible Signs of Use
        <br><br>
        • Device exhibits visible and more pronounced signs of wear, such as multiple
        scratches, paint wear, or a small dent.
        <br><br>
        • A light crack on the screen is acceptable if functionality is not affected.
        <br><br>
        • All key functions (screen, touch, camera, connectivity) remain operational.
        <br><br>
        Grade D – Non-recoverable / Rejected
        <br><br>
        • Device is severely damaged or cannot power on.
        <br><br>
        • Deep cracks, bent frame, broken screen or housing, missing parts, motherboard
        failure, corrosion, no display or touch response.
        <br><br>
        • Device cannot be connected or tested (e.g., locked by Google / iCloud / PIN).
        <br><br>
        • The device battery is swollen, or has other issues that do not meet safety
        inspection standards, such as excessive overheating or the housing being
        pushed open by the battery.
        <br><br>
        II. Smartwatches and Bands
        <br><br>
        Grade A – Excellent Condition
        <br><br>
        • Device shows normal signs of use but remains in good condition.
        <br><br>
        • No cracks, paint loss, or discoloration.
        <br><br>
        • All functions (touch, crown, sensors, Bluetooth, Wi-Fi) work properly.
        <br><br>
        • For Apple devices, battery health≥ 90%.
        <br><br>
        Grade B – Light Signs of Use
        <br><br>
        • Device shows normal signs of use but remains in good condition.
        <br><br>
        • May have 2–3 minor scratches or small scuffs; no major damage.
        <br><br>
        • All key functions (display, touch, sensors, Bluetooth) operate normally.
        <br><br>
        • For Apple devices, battery health ≥ 80%
        <br><br>
        Grade C – Visible Signs of Use
        <br><br>
        • Device has visible signs of wear such as multiple scratches, paint wear, or minor
        dents.
        <br><br>
        • Some sensors or buttons may be less responsive but core functions still work.
        <br><br>
        • Battery life slightly reduced (&lt; 80%).
        <br><br>
        Grade D – Non-recoverable / Rejected
        <br><br>
        • Device is heavily damaged or cannot power on.
        <br><br>
        • Cracked screen, broken buttons or crown, motherboard failure, account lock
        (iCloud / Google / PIN), or corrosion.
        <br><br>
        • Not eligible for trade-in.
        <br><br>
        III. Wireless Earphones
        <br><br>
        Grade A – Excellent Condition
        <br><br>
        • Device is in excellent condition, clean and free of scratches or stains.
        <br><br>
        • All functions (sound, touch, microphone, Bluetooth, charging) operate properly.
        <br><br>
        • Charging case intact and functional.
        <br><br>
        Grade B – Light Signs of Use
        <br><br>
        • Device shows light signs of use such as minor surface marks or scuffs but
        remains in good condition.
        <br><br>
        • Sound quality is normal; Bluetooth stable; charging case may show minor marks.
        <br><br>
        • Touch and microphone function properly.
        <br><br>
        Grade C – Visible Signs of Use
        <br><br>
        • Device shows visible wear such as multiple scratches, color fading, or small dents.
        <br><br>
        • Sound or microphone may be slightly degraded but remain functional.
        <br><br>
        • Bluetooth may be less stable; charging case shows visible scratches or light
        damage.
        <br><br>
        Grade D – Non-recoverable / Rejected
        <br><br>
        • Device is incomplete, cannot power on, or fails basic functions.
        <br><br>
        • Missing earbud / case, battery failure, broken charging port, Bluetooth pairing
        impossible, or water damage.
        <br><br>
        • Not eligible for trade-in.
        <br><br>
        6.8. If the device received does not match the model or serial number originally declared
        by the customer, Danghuan will proactively contact the customer to inform them of the
        new offer. If the newly received device is eligible for the Trade-In Program, a new
        quotation will be issued based on its actual condition.
        The customer must review and accept the updated quotation and sign a new Declaration
        of Ownership and Integrity corresponding to the newly received device before the tradein
        can proceed.
        If the customer does not accept the new offer within 7 calendar days, they may request
        the return of the incorrectly sent device in accordance with the terms described in Article
        6.3.
        <br><br>
        6.9. The Trade-In process requires the customer to sign and submit the Declaration of
        Ownership and Integrity for the device being traded in. Failure to properly complete, sign,
        or submit this document may result in the rejection of the trade-in request. In such cases,
        the device may be returned to the customer upon request and subject to the conditions
        stated in Article 6.3 or responsibly recycled if no response is received within the
        applicable time period.
        <br><br>
        6.10. The initial trade-in quotation provided to the customer is indicative and subject to verification. While the quoted value may remain available for a limited period following the delivery of the new device, Danghuan Europe S.L. reserves the right to review and adjust the quotation based on factors including, but not limited to, device condition, market fluctuations, and processing timelines.
        Due to the nature of the electronic devices market, device values may depreciate over time. As a general reference, prices may decrease progressively on a weekly basis, typically in the range of approximately 6%, although actual adjustments may vary depending on market conditions and product categories.
        In cases where the trade-in process is not completed within a reasonable timeframe or where market conditions significantly change, the originally quoted value may no longer apply.
        <br><br>
        ARTICLE 7 – PAYMENT CONDITIONS
        <br><br>
        7.1. Payouts are made exclusively via bank transfer to an account held in the customer’s
        name, as submitted during the trade-in registration process.
        <br><br>
        7.2. For customers residing in the EU or EEA, payment will be made via SEPA transfer
        to an IBAN linked to a valid financial institution within the SEPA zone.
        <br><br>
        7.3. For customers residing in the United Kingdom, payment may be made in GBP via
        Faster Payments or BACS transfer to a UK bank account, provided the account is held
        in the customer's name and the payment details are valid and complete.
        <br><br>
        7.4. Prepaid cards, virtual accounts, or banking details that do not match the registered
        customer name will result in payment failure and may lead to cancellation of the trade-in
        transaction.
        <br><br>
        7.5. Danghuan Europe S.L. shall not be liable for delays or errors caused by incomplete,
        incorrect, or expired banking details.
        <br><br>
        7.6. If the customer provides incorrect, invalid, or mismatched banking details, and the
        payment is successfully processed to the submitted account, Danghuan Europe S.L.
        shall not be liable for any resulting loss. The customer acknowledges full responsibility
        for ensuring the accuracy of their bank account information. No second payment will be
        issued in such cases.
        <br><br>
        7.7. Upon completion of the trade-in process, should the refundable amount specified in
        the order be less than the applicable trade-in bonus, only the residual refundable amount
        will be remitted.
        <br><br>
        7.8. A trade-in bonus (if any) will be cancelled in the event of an Product order refund.
        <br><br>
        7.9. All bank transfer fees related to trade-in payouts will be borne by Danghuan Europe
        S.L.
        <br><br>
        7.10. Please note that the total amount payable to the customer may consist of two
        separate transfers:
        (a) the trade-in device value, paid directly by Danghuan; and
        (b) any applicable promotional bonus granted by OPPO, paid separately by OPPO to
        the same bank account details provided by the customer.
        The two payments may be received at different times depending on each party’s
        processing timelines.
        <br><br>
        ARTICLE 8 – LIABILITY AND RISK OF LOSS
        <br><br>
        8.1. Customers are required to use the prepaid shipping label and logistics provider
        designated by Danghuan Europe S.L. Any alternative shipping methods will void the
        liability coverage.
        <br><br>
        8.2. A device is deemed lost if it is not tracked, confirmed, or received by Danghuan
        Europe S.L. within 15 calendar days from the date of handover to the logistics provider.
        <br><br>
        • For UPS shipments, claims must be submitted within 60 days from the shipping
        label creation date.
        <br><br>
        • For CORREOS shipments within Spain, claims should be submitted as soon
        as possible, ideally within 15 days, and no later than 1 year from the shipping
        date.
        <br><br>
        Danghuan will assist customers with the courier claim process, which generally takes 30
        to 60 days.
        <br><br>
        8.3. This liability framework applies equally to shipments from the customer to Danghuan
        Europe S.L. and to any return shipments from Danghuan Europe S.L. to the customer.
        <br><br>
        8.4. If a confirmed loss occurs under Danghuan’s logistics system, Danghuan Europe
        S.L. will assist the customer in filing a formal claim with the courier service.
        <br><br>
        8.5. Liability and compensation are strictly limited to cases where the customer used the
        authorized shipping label provided by Danghuan Europe S.L., and the shipping event is
        verifiable.
        <br><br>
        8.6. In such loss cases, compensation will not exceed the final appraised trade-in value
        of the device, as determined prior to loss confirmation.
        <br><br>
        ARTICLE 9 – PERSONAL DATA AND GDPR COMPLIANCE
        <br><br>
        9.1. All personal data provided by customers during participation in the Trade-In Program
        is processed in full compliance with applicable data protection laws, including Regulation
        (EU) 2016/679 (General Data Protection Regulation – GDPR) for EU residents, and the
        UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018
        for UK residents. Danghuan Europe S.L. acts as the Data Controller and implements
        appropriate technical and organizational measures to ensure the confidentiality, integrity,
        and security of all personal data processed in connection with the Trade-In Program.
        <br><br>
        9.2. Collected data includes, but is not limited to: name, surname, email address, postal
        address, phone number, bank account, identification documents, IMEI of the traded-in
        device, and responses provided in the evaluation form.
        <br><br>
        9.3. The data is processed exclusively for the purposes of: identity verification,
        processing and evaluating the trade-in request, managing the collection and shipment of
        the device, customer support, accounting, and executing payment. No personal data is
        used for marketing purposes or transferred to third parties without explicit consent,
        except where required by law.
        <br><br>
        9.4. The data will be retained only for as long as necessary to fulfill the trade-in
        transaction and comply with applicable legal obligations. Unless otherwise legally
        required, all customer data will be erased within 30 calendar days from the completion
        of the trade-in process and final payment. However, certain records may be retained for
        up to 90 calendar days in cases where necessary for regulatory audits, payment
        reconciliation, fraud investigation, or brand partner compliance reviews, in accordance
        with data protection laws.
        <br><br>
        9.5. Customers are solely responsible for the secure erasure of all personal information
        from their devices before shipment. This includes contacts, messages, images,
        applications, emails, browsing history, accounts, and any confidential content.
        <br><br>
        9.6. The customer must also remove any active SIM and microSD memory cards and
        disable all security features such as screen locks, passwords, and linked cloud accounts
        (e.g., Apple iCloud, Google account, Samsung Find My Mobile). Failure to do so may
        result in the device being considered ineligible.
        <br><br>
        9.7. Additional information regarding data processing and customer rights (access,
        rectification, deletion, restriction, objection) can be found in the full Privacy Policy
        available at the official website of Danghuan Europe S.L.
        <br><br>
        ARTICLE 10 – FRAUD AND NON-COMPLIANCE POLICY
        <br><br>
        10.1. Submissions involving false declarations, blacklisted, leased, tampered, or
        unowned devices will be disqualified without compensation.
        <br><br>
        10.2. Danghuan Europe S.L. reserves the right to exclude such participants from
        current and future trade-in initiatives.
        <br><br>
        10.3. Legal proceedings may be initiated in cases involving fraud, identity theft, or
        attempts to bypass eligibility requirements for commercial purposes.
        <br><br>
        ARTICLE 11 – FORCE MAJEURE
        <br><br>
        11.1. In the event of natural disasters, government restrictions, pandemics, industrial
        actions, or transportation disruptions beyond reasonable control, Danghuan Europe
        S.L. may temporarily suspend the trade-in service without liability.
        <br><br>
        11.2. Any delays or failures in performance arising from such force majeure events
        shall not be considered a breach of contract.
        <br><br>
        ARTICLE 12 – GOVERNING LAW AND JURISDICTION
        <br><br>
        12.1. These Terms and Conditions are governed by and shall be interpreted in
        accordance with the laws of Spain. This is without prejudice to any other rights of
        protection that the consumer may have under its own national legislation.
        <br><br>
        12.2. Any disputes arising under or in connection with these Terms shall be subject to
        the exclusive jurisdiction of the courts of Madrid, Spain, without prejudice to the rights
        of consumer to enforce its consumer protection rights in the customer’s country of
        residence.
      </div>
    </div>
  </div>
`;
